if (!customElements.get('product-info')) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.productForms = document.querySelectorAll('product-form');
      this.quantityInputs = document.querySelectorAll('quantity-input input[name="quantity"]');

      this.quantityInputs.forEach((input) => {
        this.updateMinusButtonState(input);
        input.addEventListener('change', () => {
          this.handleQuantityInputChange(input);
        });
      });
    }

    /**
     * updateMinusButtonState
     * @description Update the state of the minus button based on the quantity input value.
     * @param {HTMLInputElement} input - The quantity input element.
     */
    updateMinusButtonState(input) {
      const minusButton = input.closest('quantity-input').querySelector('button[name="minus"]');
      if (input.value === '1') {
        minusButton.disabled = true;
      } else {
        minusButton.disabled = false;
      }
    }

    /**
     * handleQuantityInputChange
     * @description Handle the change event for quantity inputs and sync the values across all forms.
     * @param {HTMLInputElement} changedInput - The quantity input element that triggered the change event.
     */
    handleQuantityInputChange(changedInput) {
      const newValue = changedInput.value;
      this.quantityInputs.forEach((input) => {
        if (input !== changedInput) {
          input.value = newValue;
          this.updateMinusButtonState(input);
        }
      });
      this.productForms.forEach((form) => {
        const formQuantityInput = form.querySelector('input[name="quantity"]');
        if (formQuantityInput) {
          formQuantityInput.value = newValue;
        }
      });
    }
  }
  customElements.define('product-info', ProductInfo);
}
